
import axios from "axios"
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class PublicStore extends ApiStore{
  constructor() {
    super();
  }

  getTermOfServiceUrl(){
    return axios.defaults.baseURL+'/public/company/termofservice/accept'
  }

  tosAccept(completeFunc,errorFunc){
    
    // console.log('postData',postData)
    axios.post('/public/company/termofservice/accept')
    .then(function(response){
      // console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }
}

export default new PublicStore()



// WEBPACK FOOTER //
// ./src/stores/PublicStore.js